import _export from '../internals/export.js';
import descriptors from '../internals/descriptors.js';
import objectCreate from '../internals/object-create.js';

var $ = _export;
var DESCRIPTORS = descriptors;
var create = objectCreate; // `Object.create` method
// https://tc39.es/ecma262/#sec-object.create

$({
  target: 'Object',
  stat: true,
  sham: !DESCRIPTORS
}, {
  create: create
});
